import { Button } from '@/components/ui/button'
import StorefrontStateBanner from '@/components/websites/StorefrontStateBanner'
import { useAbility } from '@/lib/casl'
import { useSeasonalStatus } from '@/lib/services/seasonal-content/seasonal-content.query'
import { Link } from '@tanstack/react-router'
import { ChevronRight } from 'lucide-react'

export default function SeasonalStatusSummary({ organizationId, enabled = true }) {
  const ability = useAbility()
  const { data: response, isLoading } = useSeasonalStatus({ organizationId, enabled })
  const status = response?.data

  if (!enabled || isLoading || !status?.active) {
    return null
  }

  const targetDesign = status.active
  const canOpenDesign = Boolean(targetDesign?.design_id && ability.can('view', 'designs'))

  return (
    <StorefrontStateBanner
      activeStatus={targetDesign}
      action={
        <Button asChild size="sm" variant="ghost" className="shrink-0">
          <Link
            to={canOpenDesign ? '/$orgId/designs/$designId' : '/$orgId/designs'}
            params={{
              orgId: String(organizationId),
              ...(canOpenDesign ? { designId: String(targetDesign.design_id) } : {}),
            }}
          >
            View seasonal update
            <ChevronRight className="size-4" />
          </Link>
        </Button>
      }
    />
  )
}
